document.addEventListener('DOMContentLoaded', function() {
  var iconboxes = document.querySelectorAll('.iconbox');
  var currentPath = window.location.pathname;

  var categories = {
    'Fleurs': {
      urls: [
        '/collections/fleurs-de-cbd',
        '/collections/doux',
        '/collections/equilibre',
        '/collections/intense'
      ],
      activeClass: 'active-fleurs',
      collection: 'fleurs'
    },
    'Résines': {
      urls: [
        '/collections/resines-de-cbd',
        '/collections/resines-doux',
        '/collections/resines-equilibre',
        '/collections/resines-intense'
      ],
      activeClass: 'active-resines',
      collection: 'resines'
    },
    'Molécules': {
      urls: [
        '/collections/les-molecules',
        '/collections/molecules-doux',
        '/collections/molecules-equilibre',
        '/collections/molecules-intense'
      ],
      activeClass: 'active-molecules',
      collection: 'molecules'
    }
  };

  // Applique data-collection sur le body pour colorer le sous-menu (Tout, Doux, etc.)
  // On vérifie chaque catégorie explicitement par ses URLs
  var matched = false;
  Object.values(categories).forEach(function(cat) {
    if (!matched && cat.urls.indexOf(currentPath) !== -1) {
      document.body.setAttribute('data-collection', cat.collection);
      matched = true;
    }
  });

  iconboxes.forEach(function(box) {
    var link = box.querySelector('a');
    var span = box.querySelector('.header__menu-link-text');
    if (!link || !span) return;

    var title = span.textContent.trim();
    var cat = categories[title];
    var hoverClass = cat ? cat.activeClass : 'active';

    // Active au chargement si l'URL courante appartient à cette catégorie
    if (cat && cat.urls.indexOf(currentPath) !== -1) {
      box.classList.add(hoverClass);
    } else if (!cat && new URL(link.href).pathname === currentPath) {
      box.classList.add('active');
    }

    // Hover
    box.addEventListener('mouseenter', function() {
      box.classList.add(hoverClass);
    });

    box.addEventListener('mouseleave', function() {
      var isCurrentActive = cat
        ? cat.urls.indexOf(currentPath) !== -1
        : new URL(link.href).pathname === currentPath;
      if (!isCurrentActive) {
        box.classList.remove(hoverClass);
      }
    });
  });
});